module.exports = __webpack_public_path__ + "static/media/blue-containers-drums-615670.d508a5c4.jpg";